module.exports = __webpack_public_path__ + "static/media/mesh basket.11.000e5a13.png";